module.exports = __webpack_public_path__ + "img/website-02.ba8ef13f.png";